import { createStyles, makeStyles } from '@material-ui/styles';
import palette from 'theme/palette';

const style = () =>
  createStyles({
    root: {
      marginTop: '10px',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      flexWrap: 'wrap'
    },
    title: {
      color: palette.common.black,
      fontSize: '1.25rem'
    },
    topBar: {
      display: 'flex',
      justifyContent: 'center',
      padding: '5px 10px',
      borderRadius: palette.borderRadius.default,
      background: palette.background.lightblue,
      color: palette.text.white,
      fontSize: '1.5rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
